export default __webpack_public_path__ + "static/media/light-italic.33c3f31b.woff";